import { ClientPartnerOptions } from "./CnManifest";

export class BankDetail {
  bankId = "";
  bankName = "";
  bankAccount = "";
  bankAccountName = "";
  constructor(fields?: Partial<BankDetail>) {
    Object.assign(this, fields);
  }
}
export class District {
  code = "";
  name = "";
  constructor(fields?: Partial<District>) {
    Object.assign(this, fields);
  }
}

export class CourierDeliveries {
  cityCode = "";
  cityName = "";
  districts: District[] = [];

  constructor(fields?: Partial<CourierDeliveries>) {
    Object.assign(this, fields);

    if (fields?.districts) {
      this.districts = fields.districts.map(d => new District(d));
    }
  }
}

export class CourierManagementDetail {
  id = 0;
  courierId = 0;
  fullname = "";
  phoneNumber = "";
  partnerType = "";
  announcementCourierType = "";
  courierType = "";
  vehicleType = "";
  vehiclePlate = "";
  partner = new ClientPartnerOptions();
  courierStatus = "";
  courierIsCod = false;
  partnerOwnershipId = 0;
  partnerOwnershipName = "";
  partnerOwnershipCode = "";
  courierAreaDeliveries: CourierDeliveries[] = [];
  bank = new BankDetail();
  partnerId = 0;
  constructor(fields?: Partial<CourierManagementDetail>) {
    Object.assign(this, fields);
  }
}

export class CourierListDevice {
  id = 0;
  deviceName = "";
  deviceOs = "";
  deviceId = "";
  lastLoginAt = "";
  isLogin = false;
  constructor(fields?: Partial<CourierListDevice>) {
    Object.assign(this, fields);
  }
}

export class CourierManagementListApprovalHistory {
  id = 0;
  type = 0;
  status = 0;
  posName = "";
  createdAt = "";
  constructor(fields?: Partial<CourierManagementListApprovalHistory>) {
    Object.assign(this, fields);
  }
}
